import { render, staticRenderFns } from "./CancelTransaction.vue?vue&type=template&id=2baf3567&scoped=true"
import script from "./CancelTransaction.vue?vue&type=script&lang=js"
export * from "./CancelTransaction.vue?vue&type=script&lang=js"
import style0 from "./CancelTransaction.vue?vue&type=style&index=0&id=2baf3567&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baf3567",
  null
  
)

export default component.exports